import { Epic, ofType } from "redux-observable";
import { Observable } from "rxjs";
import { exhaustMap } from "rxjs/operators";
import { PersonRepository } from "../../../repositories/persons.repository";
import { RootState } from "../../reducers";
import { LegalRepresentativePopupActions } from "../actions";
import { LegalRepresentativePopupSubmitForm } from "../actions/default";
import {
    LEGAL_REPRESENTATIVE_POPUP_SUBMIT_FORM,
    LEGAL_REPRESENTATIVE_POPUP_VERIFY_IF_CUSTOMER_HAS_LEGAL_REPRESENTATIVE,
} from "../constants";
import { QuotationRepository } from "../../../repositories/quotation.repository";

export const legalRepresentativePopupSubmitFormEpic: Epic<
    LegalRepresentativePopupActions,
    LegalRepresentativePopupActions,
    RootState
> = (action$) =>
    action$.pipe(
        ofType<
            LegalRepresentativePopupActions,
            LegalRepresentativePopupSubmitForm
        >(LEGAL_REPRESENTATIVE_POPUP_SUBMIT_FORM),
        exhaustMap((action) => PersonRepository.saveLegalRepresentative(action))
    );

export const legalRepresentativePopupVerifyIfCustomerHasLegalRepresentativeEpic: Epic<
    LegalRepresentativePopupActions,
    LegalRepresentativePopupActions,
    RootState
> = (action$: Observable<LegalRepresentativePopupActions>, state$) =>
    action$.pipe(
        ofType(
            LEGAL_REPRESENTATIVE_POPUP_VERIFY_IF_CUSTOMER_HAS_LEGAL_REPRESENTATIVE
        ),
        exhaustMap(() => {
            const { rucHasLegalRepresentative } = state$.value.customer;
            const quotationBody = QuotationRepository.getQuotationBody(state$);
            return QuotationRepository.saveLegalRepresentativeQuotation(
                quotationBody,
                rucHasLegalRepresentative
            );
        })
    );
